import React from 'react';
import { RootWrapper, ScreenReaderOnly } from '../Shared/SharedStyles';

const PlaceholderSVGLayer = () => (
    <svg width="100%" height="300" viewBox="0 0 100% 300" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g fillOpacity="0.10" fill="#8E90A2">
            <rect x="0%" y="10px" width="45%" height="50px" rx="2" />
            <rect x="0%" y="80px" width="20%" height="25px" rx="2" />
            <rect x="0%" y="120px" width="100%" height="50px" rx="2" />
            <rect x="0%" y="205px" width="40%" height="50px" rx="2" />
            <rect x="60%" y="205px" width="100%" height="50px" rx="2" />
        </g>
    </svg>
);

const EmailModalLoadingIndicator = ({ shouldAnnounce = true, ...rest }) => (
    <RootWrapper {...rest}>
        {shouldAnnounce && <ScreenReaderOnly>Loading / Chargement</ScreenReaderOnly>}
        <PlaceholderSVGLayer />
    </RootWrapper>
);

export default EmailModalLoadingIndicator;
